export default __webpack_public_path__ + "static/media/flag-bahamas.79dc9039.svg";